import { defineComponent as _defineComponent } from 'vue'
import AccountHeader from './shared/AccountHeader.vue';
import AppointmentPayment from './appointments/AppointmentPayment.vue';
import AppointmentService from './appointments/AppointmentService.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import OrderSummaryLine from 'JS/components/order/OrderSummaryLine.vue';
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import WorkOrderPromoOfferDiscountLine from 'JS/automotive/auto-service-scheduler/components/work-order/WorkOrderPromoOfferDiscountLine.vue';
import { computed } from 'vue';
import { getAppointmentDateString, getAppointmentEndDate, getAppointmentStartDate, getAppointmentTitleString, getDropoffInstructions, getSelectedServices } from 'JS/automotive/auto-service-scheduler/utils/helpers';
import { ICheckoutPayment } from 'JS/types/Checkout';
import { IconName } from 'JS/constants/icons';
import { ISavedVehicle, IServiceConfirmationResource, IWorkOrderConfirmationResource } from 'JS/types/Automotive';
import { IWorkOrderCustomerInfoResource, IWorkOrderPaymentInfoResource, IWorkOrderSummaryResource, WorkOrderAppointmentInfo, WorkOrderAppointmentInfoState, WorkOrderTotalType, WorkOrderType } from 'JS/automotive/auto-service-scheduler/types/session';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentDetailApp',
  props: {
    workOrder: null
  },
  setup(__props: any) {

const props = __props as {
	workOrder: IWorkOrderConfirmationResource | null;
}



const orderId = computed(() => props.workOrder?.orderId);
const orderHash = computed(() => props.workOrder?.orderHash);

const contactInfo = computed(() => props.workOrder?.customerInfo);
const appointmentInfo = computed(() => props.workOrder?.appointmentInfo);
const workOrderSummary = computed(() => props.workOrder?.workOrderSummary);
const paymentInfo = computed<IWorkOrderPaymentInfoResource>(() => props.workOrder.paymentInfo);


const selectedServices = computed<IServiceConfirmationResource[]>(() => props.workOrder?.services);

const paymentMethods = computed<ICheckoutPayment[]>(() => {
	return paymentInfo?.value.paymentMethods ?? [];
});

const vehicle = computed<ISavedVehicle>(() => workOrderSummary.value.vehicleInfo);
const vehicleLayout = computed(() => vehicle.value.iconType == null ? 'no-icon' : 'scheduler');

const startDate = computed<Date>(() => getAppointmentStartDate(appointmentInfo.value));
const endDate = computed<Date>(() => getAppointmentEndDate(appointmentInfo.value));

const startTime = computed(() => startDate.value.toLocaleTimeString('en-us', {
	hour: 'numeric',
	minute: '2-digit'
}));

const endTime = computed(() => endDate.value.toLocaleTimeString('en-us', {
	hour: 'numeric',
	minute: '2-digit'
}));

const orderType = computed<WorkOrderType>(() => props.workOrder?.type);

const appointmentDate = computed(() => getAppointmentDateString(startDate.value));
const appointmentTitle = computed(() => getAppointmentTitleString(orderType.value) + " Appointment");

const dropoffInstructions = computed(() => getDropoffInstructions(appointmentInfo.value.state));

const showServiceProduct = computed(() => orderType.value !== WorkOrderType.ServiceOnly);

const appointmentTypeIcon = computed<IconName>(() =>
	appointmentInfo.value.state === WorkOrderAppointmentInfoState.Dropoff
		? 'auto-drop-off'
		: 'auto-wait-appt'
);

const appointmentTypeTitle = computed(() => {
	if (appointmentInfo.value.state === WorkOrderAppointmentInfoState.TimeSlot) {
		return 'Make an Appointment';
	}

	if (appointmentInfo.value.state === WorkOrderAppointmentInfoState.Dropoff) {
		return 'Same Day Drop Off Service';
	}

	return '';
});

const totalLabel = computed(() => {
	if (props.workOrder?.workOrderSummary?.total?.type === WorkOrderTotalType.Normal && props.workOrder.workOrderSummary.total.showAsEstimate) {
		return "Estimated Subtotal: ";
	}

	return "Order Total: ";
});

return { __sfc: true,props, orderId, orderHash, contactInfo, appointmentInfo, workOrderSummary, paymentInfo, selectedServices, paymentMethods, vehicle, vehicleLayout, startDate, endDate, startTime, endTime, orderType, appointmentDate, appointmentTitle, dropoffInstructions, showServiceProduct, appointmentTypeIcon, appointmentTypeTitle, totalLabel, AccountHeader, AppointmentPayment, AppointmentService, Icon, LinkButton, OrderSummaryLine, SavedVehicle, WorkOrderPromoOfferDiscountLine, WorkOrderAppointmentInfoState }
}

})